import { put, take, fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';

import * as actions from 'actions';
import * as api from 'api';

export function* watchForCreatedJournalEntry() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.JOURNAL_ENTRY_CREATE_SUCCESS);
    yield put(actions.journalEntriesFetch(1));
    yield put(actions.infoShow('success', action.successMessage));
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.JOURNAL_ENTRIES_FETCH, request(api.journalEntriesFetch, 'page')),
    fork(takeLatest, actions.JOURNAL_ENTRY_CREATE, request(api.journalEntryCreate, 'emoji', 'text')),
    fork(takeLatest, actions.JOURNAL_EMOJIS_FETCH, request(api.journalEmojisFetch)),
    fork(watchForCreatedJournalEntry)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/journal/sagas.js
 **/